import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App, { history } from './App'
import { hotjar } from 'react-hotjar'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import Error500 from './pages/Error500'
import { ErrorBoundary } from 'react-error-boundary'

// hotjar
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'production') {
  hotjar.initialize(2806820, 6)
  history.listen(location => {
    try {
      hotjar.stateChange(location.pathname + location.search)
    } catch (e) {
      // nope
    }
  })
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister()

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={Error500}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
)
